var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.668 2.00167C8.668 1.63234 8.36933 1.33301 8 1.33301C7.63067 1.33301 7.332 1.63234 7.332 2.00167V2.47034C4.33733 2.80367 2 5.35101 2 8.43701V8.64834C2 9.35767 2.97067 9.58101 3.274 8.92834C3.45133 8.54301 3.922 8.28434 4.44467 8.28434C4.968 8.28434 5.43867 8.54367 5.61533 8.93034C5.85667 9.45567 6.60267 9.44301 6.834 8.91701C6.93133 8.71567 7.11067 8.55367 7.332 8.44234V13.0277C7.332 13.1937 7.18067 13.3303 6.994 13.3303C6.80733 13.3303 6.66667 13.1937 6.66667 13.0277V12.6617H5.33333V13.0277C5.33333 13.9317 6.07067 14.6663 6.994 14.6663C7.91667 14.6663 8.668 13.9317 8.668 13.0277V8.44367C8.894 8.55767 9.076 8.72301 9.17067 8.93034C9.41133 9.45634 10.158 9.44234 10.3893 8.91701C10.5707 8.53834 11.0373 8.28434 11.554 8.28434C12.078 8.28434 12.5487 8.54367 12.7253 8.93034C13.0253 9.58234 14 9.36567 14 8.65167V8.43701C14 5.35101 11.6627 2.80367 8.668 2.47034V2.00167Z",
    fill: "#CE2323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.ff38ec2e22c04851360197bed8019371.svg";
export { ForwardRef as ReactComponent };